module.exports = __webpack_public_path__ + "static/hero-authoring-2f211dad1d5b18e3b6a4ff32f0ff9889.svg";